import React from 'react'

export const exitSVG = <svg className="exitSVG" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 22 22" enableBackground="new 0 0 22 22;" xmlSpace="preserve">
<g id="Group_3982" transform="translate(-19579 -18870)">
	<g id="Group_1952" transform="translate(7.353 6.367)">
		<path id="Path_1000" className="st0" d="M19587.8,18871.3l2.4,2.4h-11.2v1.8h11l-2.3,2.3l1.3,1.3l4.6-4.6l-4.6-4.6L19587.8,18871.3z"
			/>
	</g>
	<g>
		<defs>
			<rect id="SVGID_1_" x="19579" y="18870" width="22" height="22"/>
		</defs>
		<clipPath id="SVGID_2_">
			<use xlinkHref="#SVGID_1_"/>
		</clipPath>
		<g id="Group_1954" transform="translate(0 0)" className="st1">
			<g id="Group_1953" transform="translate(0 0)">
				<path id="Path_1001" className="st0" d="M19590,18890.2c-5.1,0-9.2-4.1-9.3-9.2c0-5.1,4.2-9.2,9.3-9.2c2.9,0,5.7,1.4,7.4,3.7
					l1.3-1.3c-2.1-2.7-5.3-4.2-8.7-4.2c-6.1,0-11,4.9-11,11c0,6.1,4.9,11,11,11c3.3,0,6.5-1.5,8.6-4.1l-1.3-1.3
					C19595.6,18888.9,19592.9,18890.2,19590,18890.2"/>
			</g>
		</g>
	</g>
</g>
</svg>

export const passIcon = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" 
width="18px" height="18px" viewBox="0 0 30 30" enableBackground="new 0 0 30 30" xmlSpace="preserve">
<g>
    <g>
        <path d="M8.104,12.259v2.074l2.033-0.701l0.37,1.028l-2.031,0.662l1.259,1.757l-0.924,0.66l-1.215-1.826
            L6.36,17.739l-0.951-0.66l1.277-1.757l-2.051-0.662l0.372-1.034l2.013,0.726v-2.094H8.104z"/>
        <path d="M15.53,12.259v2.074l2.036-0.701l0.371,1.028l-2.032,0.662l1.257,1.757l-0.922,0.66l-1.215-1.826
            l-1.236,1.826l-0.95-0.66l1.277-1.757l-2.051-0.662l0.373-1.034l2.014,0.726v-2.094H15.53z"/>
        <path d="M22.961,12.259v2.074l2.032-0.701l0.371,1.028l-2.029,0.662l1.258,1.757l-0.922,0.66l-1.218-1.826
            l-1.237,1.826l-0.949-0.66l1.277-1.757l-2.052-0.662l0.374-1.034l2.014,0.726v-2.094H22.961z"/>
    </g>
    <g>
        <path fill="#DFDFDF" d="M26.537,20.745H3.464C2.106,20.745,1,19.64,1,18.282v-6.565c0-1.356,1.107-2.461,2.465-2.461h23.073
            c1.357,0,2.463,1.105,2.463,2.461v6.565C29,19.64,27.895,20.745,26.537,20.745z M3.464,10.532c-0.653,0-1.188,0.531-1.188,1.185
            v6.565c0,0.652,0.534,1.186,1.188,1.186h23.073c0.652,0,1.188-0.533,1.188-1.186v-6.565c0-0.653-0.535-1.185-1.188-1.185H3.464z"
            />
    </g>
</g>
</svg>





// WEBPACK FOOTER //
// ./src/Images/SettingsSGV.js